
import React from 'react';
import Select from 'react-select';

export default class ProductsDetailsSelector extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoaded: false,
            all_products_details: [],
            displayed_products_details: [],
            product_selected: null
        };

        this.selectStyles = {
            menu: base => ({
                ...base,
                marginTop: 0,
                'z-index': 10
            })
        }
    }

    componentDidMount() {
        let url = ENV.base_lang_url + "myspace/providers//ajaxGetter/get_mr_products_details_by_hotel";
        const params = new URLSearchParams();
        params.append('hotels_id', this.props.hotels_id);
        params.append('lang', this.props.client_lang);
        fetch(url, {
            method: 'POST',
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
            body: params.toString()
        })
            .then(rtn => rtn.json())
            .then(result => {
                this.setState({
                    all_products_details: result,
                    isLoaded: true
                }, () => this.handleLoad());
            });

    }


    handleChange = (product_detail) => {
        this.setState({ product_selected: product_detail });
        if (this.props.onChange) {
            this.props.onChange(product_detail);
        }
    }

    handleLoad = () => {
        if (this.props.onLoad) {
            this.props.onLoad();
        }

        let product_selected = null;
        product_selected = this.state.all_products_details.filter((product) => {
            return product.value == this.props.defaultValue;
        });
        if(product_selected && product_selected.length > 0) {
            this.handleChange(product_selected[0]);
        }
    };

    getDisplayedProductsDetails = () => {
        let displayed_products_details = [];
        if (this.state.isLoaded && this.state.all_products_details.length > 0 && this.props.locations.length > 0) {
            let locations_ids_selected = [];
            this.props.locations.map((location) => {
                locations_ids_selected.push(parseInt(location.value));
            });
            locations_ids_selected.sort();

            this.state.all_products_details.map((detail) => {
                let locations_ids = detail.locations_ids;
                locations_ids.sort();

                if (JSON.stringify(locations_ids) == JSON.stringify(locations_ids_selected) || detail.value == null) {
                    displayed_products_details.push(detail);
                }
            });
        }
        return displayed_products_details;
    }

    render() {
        let options = this.getDisplayedProductsDetails();
        return (
            <div className={(this.state.product_selected == null || this.state.product_selected.value == null) ? 'text-gc-orange' : 'text-gc-green'}>
                {this.props.label && (
                    <label>{this.props.label}</label>
                )}
                <Select
                    options={options}
                    onChange={this.handleChange}
                    value={this.state.product_selected}
                    classNamePrefix="react-select"
                    placeholder={this.props.trad.placeholder}
                    styles={this.selectStyles}
                >
                </Select>
            </div>
        )
    }
}

ProductsDetailsSelector.defaultProps = {
    trad: TRAD.ProductsDetailsSelector ?? {}
};